import React from "react";
import { ViewBlockHeader } from "./ViewBlockHeader";
import PredefinedFuncSvg from "../../../svg/PredefinedFuncSvg";
import useNodeContext from "../../../hooks/useNodeContext";
import { PredefinedFuncBlockFormType } from "../../../../types/bert";
import { isDefined } from "@convin/utils/helper/common.helper";
import { Box, Divider } from "@mui/material";
import BlockItem from "./BlockItem";
import { predefinedFunctionOptions } from "../../../constants";

const PredefinedFunction = () => {
    const { nodeDataToUpdate } = useNodeContext() as {
        nodeDataToUpdate: PredefinedFuncBlockFormType;
    };
    const predefinedFunction = isDefined(nodeDataToUpdate)
        ? { ...nodeDataToUpdate }
        : {
              name: "",
              function_type: "",
              min: null,
              max: null,
          };
    return (
        <div>
            <ViewBlockHeader
                icon={<PredefinedFuncSvg />}
                title="Predefined Function"
            />
            <Box
                className="flex flex-col "
                sx={{
                    p: 2,
                    gap: 1.5,
                }}
            >
                <BlockItem title="Block Name" value={predefinedFunction.name} />
                <Divider />
                <BlockItem
                    title="Selected Predefined Function"
                    value={
                        predefinedFunctionOptions.find(
                            (option) =>
                                option.id === predefinedFunction.function_type
                        )?.label
                    }
                />
                <Divider />

                <div className="flex justify-between">
                    <BlockItem title="Minimum" value={predefinedFunction.min} />
                    <BlockItem title="Maximum" value={predefinedFunction.max} />
                </div>
            </Box>
        </div>
    );
};

export default PredefinedFunction;
